// Shared constants and utilities for the Stores module.
// Single source of truth — never duplicate these in the parent Stores.jsx.

export const QUALITY_INSPECT_ROLES = ['super_admin', 'Quality', 'PM', 'MD', 'CEO', 'CMD'];

export const canRunInspection = (user) => !!user && (
  user.role === 'super_admin' ||
  QUALITY_INSPECT_ROLES.includes(user.role) ||
  QUALITY_INSPECT_ROLES.includes(user.department)
);

export const MPR_PLAN_FREQUENCIES = ['Daily', 'Weekly', 'Monthly', 'Quarterly', 'Half-Yearly', 'Yearly', 'Entire Project'];
export const MPR_SOURCE_BASES = ['WBS', 'BOQ', 'DPR'];

export const mprStatusClass = (s) => {
  const k = (s || '').toLowerCase();
  if (k.includes('approved') && !k.includes('pending')) return 'bg-emerald-100 text-emerald-700';
  if (k.includes('pending')) return 'bg-amber-100 text-amber-700';
  if (k.includes('reject')) return 'bg-rose-100 text-rose-700';
  if (k.includes('rfq') || k.includes('awarded') || k.includes('closed')) return 'bg-blue-100 text-blue-700';
  return 'bg-gray-100 text-gray-600';
};

export const blankLine = () => ({ _key: Math.random(), material_id: '', material_name: '', uom: '', qty: '', notes: '' });

export const EVIDENCE_META = {
  quantity_check: { label: 'Quantity Check', hint: 'Photo of received material/count' },
  quality_check: { label: 'Quality Check', hint: 'Condition / surface / damage check' },
  invoice_check: { label: 'Tax Invoice', hint: 'Supplier invoice / challan' },
  mtc_check: { label: 'Material Test Certificate', hint: 'MTC document for the material' },
};

export const REJECT_REASONS = ['Damaged', 'Rusted / Corroded', 'Wrong specification', 'Short quantity', 'Quality below standard', 'Expired / Old stock', 'Wrong grade', 'Documentation mismatch'];

export function compressImageFile(file, maxDim = 1600, quality = 0.7) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        let { width, height } = img;
        if (Math.max(width, height) > maxDim) {
          if (width >= height) {
            height = Math.round((height * maxDim) / width);
            width = maxDim;
          } else {
            width = Math.round((width * maxDim) / height);
            height = maxDim;
          }
        }
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL('image/jpeg', quality));
      };
      img.onerror = () => reject(new Error('Could not read image'));
      img.src = reader.result;
    };
    reader.onerror = () => reject(new Error('Could not read file'));
    reader.readAsDataURL(file);
  });
}
